// removed by extract-text-webpack-plugin
module.exports = {"component":"_1r7mHBypZ2CxFawFt1_Eow"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ThankYouPage/CardPage/CardDefault/cardDefault.css
// module id = 1265
// module chunks = 2